module.exports = __webpack_public_path__ + "static/media/poster.215d3e35.png";